module.exports = __webpack_public_path__ + "media/images/svgs/delivery_truck_icon-05c0b87ee77b3db02f024670d40ab968.svg";